import React from 'react';
import { Box, Container, Typography, CircularProgress, Chip } from '@mui/material';
import Navbar from './Navbar';

/** Shared chrome for all Master / settings screens — modern GIRVI look. */
export default function MasterPageShell({
  title,
  subtitle = 'Master data',
  children,
  loading = false,
  actions = null,
}) {
  return (
    <>
      <Navbar />
      <Box
        className="girvi-master-page"
        sx={{
          minHeight: 'calc(100vh - 56px)',
          background:
            'radial-gradient(900px 420px at 8% -8%, rgba(201,162,77,0.16), transparent 55%), radial-gradient(700px 360px at 100% 0%, rgba(29,78,216,0.08), transparent 50%), linear-gradient(180deg, #eef2f7 0%, #f7f8fb 45%, #f3f5f8 100%)',
          py: { xs: 2, md: 2.5 },
        }}
      >
        <Container maxWidth="lg" sx={{ px: { xs: 1.5, sm: 2 } }}>
          <Box
            sx={{
              mb: 2,
              p: { xs: 1.75, md: 2.25 },
              borderRadius: 3,
              background: 'linear-gradient(115deg, #0b1220 0%, #16233a 55%, #1e3a5f 100%)',
              border: '1px solid rgba(212,175,106,0.28)',
              boxShadow: '0 12px 32px rgba(15,23,42,0.14)',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1.5,
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: 10,
                  fontWeight: 800,
                  letterSpacing: '0.16em',
                  textTransform: 'uppercase',
                  color: 'rgba(245,230,200,0.7)',
                  mb: 0.4,
                }}
              >
                {subtitle}
              </Typography>
              <Typography
                component="h1"
                sx={{
                  fontSize: { xs: 20, md: 24 },
                  fontWeight: 800,
                  letterSpacing: '-0.02em',
                  color: '#f8fafc',
                  lineHeight: 1.15,
                }}
              >
                {title}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {actions}
              <Chip
                size="small"
                label="GIRVI Master"
                sx={{
                  height: 26,
                  fontWeight: 700,
                  bgcolor: 'rgba(240,217,160,0.14)',
                  color: '#f5e6c8',
                  border: '1px solid rgba(240,217,160,0.35)',
                }}
              />
            </Box>
          </Box>

          {loading ? (
            <Box sx={{ display: 'grid', placeItems: 'center', py: 8 }}>
              <CircularProgress size={36} sx={{ color: '#c9a24d' }} />
            </Box>
          ) : (
            children
          )}
        </Container>
      </Box>
    </>
  );
}

export const masterPaperSx = {
  p: { xs: 2, md: 2.5 },
  borderRadius: 3,
  border: '1px solid #e2e8f0',
  bgcolor: 'rgba(255,255,255,0.92)',
  boxShadow: '0 8px 24px rgba(15,23,42,0.05)',
  height: '100%',
};

export const masterListPaperSx = {
  borderRadius: 3,
  border: '1px solid #e2e8f0',
  bgcolor: 'rgba(255,255,255,0.92)',
  boxShadow: '0 8px 24px rgba(15,23,42,0.05)',
  overflow: 'hidden',
};

export const masterSectionTitleSx = {
  fontSize: 15,
  fontWeight: 780,
  color: '#0f172a',
  mb: 1.5,
};

export const masterPrimaryBtnSx = {
  mt: 2,
  mb: 1,
  py: 1.15,
  borderRadius: 2,
  textTransform: 'none',
  fontWeight: 750,
  background: 'linear-gradient(120deg, #0f172a 0%, #1e3a5f 100%)',
  boxShadow: '0 8px 18px rgba(15,23,42,0.2)',
  '&:hover': {
    background: 'linear-gradient(120deg, #152238 0%, #254a75 100%)',
    boxShadow: '0 10px 22px rgba(15,23,42,0.28)',
  },
};

export const masterFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    bgcolor: '#f8fafc',
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#c9a24d' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#c9a24d', borderWidth: 1.5 },
  },
};

export const masterTableHeadCellSx = {
  fontWeight: 750,
  fontSize: 11,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: '#64748b',
  bgcolor: '#f8fafc',
  borderBottom: '1px solid #e2e8f0',
  py: 1.25,
};
